// src/app/components/ValidationDecisionStatusPanel.tsx

import { Box } from "@mantine/core";
import StandardRoomValidationStatusSection from "./ValidationDecisionStatusSection";
import { ValidationDecisionCommentsSection } from "./ValidationDecisionCommentsSection";

type Props = {
  /**
   * Key på formen "<validationKey>.<discipline>"
   * f.eks. "standardRoom.E", "standardRoom.V", "rie.RIV" osv.
   */
  validationDecisionKey: string;
};

/**
 * Generisk wrapper-komponent for valideringsbeslut.
 * Orkestrerer layouten for status (og senere kommentarer).
 */
export const ValidationDecisionStatusPanel: React.FC<Props> = ({ validationDecisionKey }) => {
  return (
    <Box
      p="sm"
      style={{
        borderRadius: 8,
        border: "1px solid #e0e0e0",
        backgroundColor: "#f8f9fa",
      }}
    >
      {/* Inntil vi gjør selve status-seksjonen generisk, bruker vi disiplinen her */}
      <StandardRoomValidationStatusSection validationDecisionKey={validationDecisionKey} />
      <ValidationDecisionCommentsSection validationDecisionKey={validationDecisionKey} />
    </Box>
  );
};
